<!-- <section class="tabHeader">
    <h2>Legislative Groups</h2>
    <p>This is the list of legislative groups that will be in the list of email recipients to be displayed for the email form.</p>
</section> -->

<mat-card>
    <div class="action-container">
        <h2 class="table-title">Legislative Members</h2>

        <div class="search-container" color="primary">
            <app-search-bar #search (searchEvent)="applyFilter($event);" (clearSearchEvent)="clearFilter();"></app-search-bar>
        </div>
        
        <div class="action-buttons">
            <button mat-mini-fab color="primary" (click)="addRecipient()" aria-label="Add New Email Recipient" matTooltip="Add Email Recipient">
                <mat-icon style="padding-right: 0; margin-right: 0">add</mat-icon>
                <!-- <span>Add</span> -->
            </button>
        </div>
    </div>

    <table mat-table [dataSource]="dataSource" [trackBy]="trackBy">
        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef style="width: 125px"></th>
            <td mat-cell *matCellDef="let recipient">
                <button mat-flat-button color="primary" (click)="editRecipient(recipient)">Edit</button>
                <!-- <button mat-flat-button color="accent" (click)="expandedEvent = expandedEvent === event ? null : event">Details</button> -->
                <button mat-flat-button color="warn" (click)="deleteRecipient(recipient)">Delete</button>
                <!-- <button mat-icon-button color="primary" [matMenuTriggerFor]="menu">
                    <mat-icon>more_vertical</mat-icon>
                </button>
                <mat-menu #menu="matMenu" style="width: 150px">
                    <button mat-menu-item (click)="editItem(item)"><mat-icon color="primary">edit</mat-icon>Edit</button>
                <button mat-menu-item (click)="viewItem(item)">
                    <mat-icon color="primary">visibility</mat-icon>View Details
                </button>
                <button mat-menu-item (click)="deleteItem(item)"><mat-icon color="warn">delete</mat-icon>Delete</button>
                </mat-menu> -->
            </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <!-- <td mat-cell *matCellDef="let recipient">
                {{ recipient.prefix }} 
                {{ recipient.firstName }} 
                {{ recipient.middleName }} 
                {{ recipient.nickname ? ('"' + recipient.nickname + '"') : null }} 
                {{ recipient.lastName }} 
                {{ recipient.suffix }}
            </td> -->
            <td mat-cell *matCellDef="let recipient">
                {{ recipient.name }} 
            </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let recipient">
                {{ recipient.email }}
            </td>
        </ng-container>

        <!-- Group Column -->
        <ng-container matColumnDef="group">
            <th mat-header-cell *matHeaderCellDef>Group</th>
            <td mat-cell *matCellDef="let recipient">
                <!-- <mat-form-field appearance="standard">
                    <mat-select [formControl]="toppings" multiple>
                      <mat-select-trigger>
                        {{toppings.value ? toppings.value[0].groupName : ''}}
                        <span *ngIf="toppings.value?.length > 1" class="example-additional-selection">
                          (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
                        </span>
                      </mat-select-trigger>
                      <mat-option *ngFor="let topping of legislationGroups" [value]="topping">{{topping.groupName}}</mat-option>
                    </mat-select>
                  </mat-form-field> -->

                <app-group-tags
                    [recipient]="recipient"
                    [groups]="groups"
                >
                </app-group-tags>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay; let even = even" [class.evenRow]="even"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="columnsToDisplay.length">
                No recipients matching the filter
                <span *ngIf="search.value"> "{{ search.value }}"</span>
            </td>
        </tr>
    </table>

    <div *ngIf="isLoading" style="padding: 1em">Loading data...</div>
</mat-card>